import { RULER_BADGE_MIN_WIDTH } from '../constants';

/**
 * Inline CSS for the ruler badge HTML. Plot line labels are rendered by
 * Highcharts with `useHTML`, outside the React tree, so JSS classes do not
 * apply and inline styles are required.
 */

/**
 * Style for the badge container.
 * @param bgColor Badge background color.
 * @param hasComparison Whether the badge shows deltas (needs extra width).
 * @returns Inline CSS string.
 */
export const badgeContainerStyle = (bgColor: string, hasComparison: boolean): string => {
  const minWidth = hasComparison ? RULER_BADGE_MIN_WIDTH.compared : RULER_BADGE_MIN_WIDTH.single;
  return `background:${bgColor};color:#FFFFFF;padding:4px 6px;border-radius:5px;`
    + `font-family:Inter,-apple-system,sans-serif;min-width:${minWidth}px;`
    + 'box-shadow:0 2px 6px rgba(0,0,0,0.18);';
};

export const badgeTitleStyle = 'font-size:9px;font-weight:700;letter-spacing:0.03em;margin-bottom:2px;';

export const badgeRowStyle = 'display:flex;justify-content:space-between;gap:6px;font-size:8px;line-height:1.3;';

export const badgeNameStyle = 'opacity:0.9;';

/**
 * Style for the series color dot.
 * @param color Series color.
 * @returns Inline CSS string.
 */
export const badgeDotStyle = (color: string): string => (
  `display:inline-block;width:5px;height:5px;background:${color};`
  + 'border-radius:50%;margin-right:3px;vertical-align:middle;'
);

export const badgeValueCellStyle = 'white-space:nowrap;';

export const badgeValueStyle = 'font-weight:700;font-variant-numeric:tabular-nums;';

/**
 * Style for the delta between both rulers.
 * @param color Delta color (positive/negative/neutral).
 * @returns Inline CSS string.
 */
export const badgeDeltaStyle = (color: string): string => (
  `color:${color};font-weight:700;font-size:7.5px;margin-left:4px;`
  + 'font-variant-numeric:tabular-nums;'
);

export const badgeEmptyStyle = 'font-size:8px;opacity:0.8;';
